import { render, staticRenderFns } from "./StoreReviews.vue?vue&type=template&id=6b312b78"
import script from "./StoreReviews.vue?vue&type=script&lang=js"
export * from "./StoreReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports